import requestor from "shared/service/requestor";

export default class ProjectApi {
  common = () => requestor.get("/project/common");
  sendModelToModeration = (modelTypeId, modelId) =>
    requestor.patch("/project/send-model-to-moderation", { model_type_id: modelTypeId, model_id: modelId });

  client = {
    all: (page = 1, search = "") =>
      requestor.get("/project/clients", {
        page: page,
        filter: { search: search },
      }),
    one: (id) => requestor.get("/project/client_one", { id: id }),
    toggleBan: (id) => requestor.patch("/project/client_toggle_ban", { id: id }),
    comment: (clientId, text) =>
      requestor.post("/project/client_comment", {
        Comment: { client_id: clientId, text: text },
      }),
  };

  order = {
    all: (page = 1, search = "", dateFrom = "", dateTo = "", status = "", state = "", itemId = "") =>
      requestor.get("/project/order_all", {
        page: page,
        filter: {
          search: search,
          date_from: dateFrom,
          date_to: dateTo,
          status: status,
          state: state,
          item_id: itemId,
        },
      }),
    one: (id) => requestor.get("/project/order_one", { id: id }),
    comment: (id, comment) =>
      requestor.patch("/project/order_user_comment_update", {
        id: id,
        comment: comment,
      }),
    npd: {
      downloadOfflineReceipt: (invoiceId) => requestor.post("/project/order_npd_download-offline-receipt", { id: invoiceId }),
    }
  };

  ticket = {
    all: (page) =>
      requestor.get("/project/ticket_all", {
        page: page,
      }),
    one: (id) =>
      requestor.get("/project/ticket_one", {
        id: id,
      }),
  };

  customerQuestion = {
    all: (page) =>
      requestor.get("/project/customer_question_all", {
        page: page,
      }),
    one: (id) =>
      requestor.get("/project/customer_question_one", {
        id: id,
      }),
  };

  settings = {
    get: () => requestor.get("/project/settings_get"),
    save: (form) => requestor.patch("/project/project_settings_save", { Project: form }),
    userNotify: {
      create: (form) => requestor.post("/project/user_notify_settings_create", form),
      save: (form) =>
        requestor.patch("/project/user_notify_settings_save", {
          UserNotifySettings: form,
        }),
      get: () => requestor.get("/project/user_notify_settings_get"),
    },
    projectLinks: {
      create: (form) => requestor.post("/project_links/create", form),
      save: (form) =>
        requestor.patch("/project_links/save", {
          ProjectLinks: form,
        }),
    },

    store:  {
      get: () => requestor.get("/project/store_get"),
      create: (form) => requestor.post("/project/store_create", form),
      save: (form) =>
        requestor.put("/project/store_save", {
          ProjectStore: form,
        }),
    }
  };

  organization = {
    save: (form) =>
      requestor.post("/project/organization_save", {
        Organization: form,
      }),
    get: () => requestor.get("/project/organization_get"),
    savePhone: (organization_id, phone) => requestor.patch("/project/organization_save-phone", {
      organization_id: organization_id,
      phone: phone
    }),
    saveBank: (organization_id, bank) => requestor.patch("/project/organization_save-method-instance", {
      organization_id: organization_id,
      bank: bank
    }),
    phoneVerifyRequest: () => requestor.post("/project/organization_phone_verify_request"),
    phoneVerifySubmit: (code) =>
      requestor.put("/project/organization_phone_verify_submit", {
        code: code,
      }),
    bindNpd: () => requestor.patch("/project/organization_npd-bind"),
    unbindNpd: () => requestor.patch("/project/organization_npd-unbind")
  };

  landing = {
    all: (page = 1, search = "") =>
      requestor.get("/project/landing_all", {
        page: page,
        filter: {
          search: search,
        }
      }),
    one: (id) => requestor.get("/project/landing_one", { id: id }),
    create: () => requestor.post("/project/landing_create"),
    save: (form) => requestor.patch("/project/landing_save", { Landing: form }),
    delete: (id) => requestor.delete("/project/landing_delete", { id: id }),
    toggle: (id) => requestor.patch("/project/landing_toggle", { id: id }),
    templates: () => requestor.get("/project/landing_templates")
  }

  secureDeal = {
    getLink: () => requestor.get("/project/secure_deal_get-link"),
    getCards: () => requestor.get("/project/secure_deal_get-cards"),
  };

  inviteUser = (role_id, nick_name) =>
    requestor.put("/project/invite_user", {
      role_id: role_id,
      nick_name: nick_name,
    });

  excludeUser = (user_id) =>
    requestor.delete("/project/exclude_user", {
      id: user_id,
    });
}
